<main>
<div class="container-box browse-page">
  <div class="alert valign-children-middle mar-top-20" *ngIf="errorMessage!=null">
    <div class="alert-error" aria-label="Alert.">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div>
      <h2>Error</h2>
      <p>{{errorMessage}}</p>
    </div>
  </div>
  <h1 *ngIf="!isFn">Marketplace</h1>
  <h1 *ngIf="isFn">FirstNet Apps & Solutions</h1>
  <p>Discounts and credits will be applied on the <strong>Checkout</strong> page after you select a billing account.</p>
  <div class="row {{columnCount}} catalog4column">
    <!-- product tiles start -->
    <div class="row-box">
      <ng-template let-cardDetail ngFor [ngForOf]="cardDetails">
        <app-product-card [card]="cardDetail"></app-product-card>
      </ng-template>
    </div>
    <!-- product tiles end -->
  </div>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>
</main>